import { Component } from '@angular/core';

@Component({
  selector: 'app-linkedin',
  templateUrl: './linkedin.component.html',
  styles: [
  ]
})
export class LinkedinComponent  {

  constructor() { }

  

}
